import React from "react";
import { Button, Card, Empty, Space, Switch, Tag, Typography } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const { Paragraph, Text } = Typography;

const ScheduleDraftTrackConfigPanel = ({
    title = "轨道与参考",
    tracks = [],
    showEditableTracks,
    showDemandReferences,
    visibleReferenceTrackIds,
    referenceTrackItems = [],
    onToggleEditableTracks,
    onToggleDemandReferences,
    onToggleReferenceTrack,
    onMoveReferenceTrack,
    onRemoveReferenceTrack,
    onOpenAddReferenceTrack,
    showDemandReferenceControl = false,
}) => {
    const primaryReferenceTrack = referenceTrackItems[0] || null;

    return (
        <Card title={title} className="schedule-draft-side-card" size="small">
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
                <div className="schedule-draft-config-row">
                    <div>
                        <Text strong>编辑轨</Text>
                        <Paragraph className="schedule-draft-config-help">控制当前航班计划的编辑轨是否进入时间线。</Paragraph>
                    </div>
                    <Switch checked={showEditableTracks} onChange={onToggleEditableTracks} />
                </div>

                {showDemandReferenceControl ? (
                    <div className="schedule-draft-config-row">
                        <div>
                            <Text strong>需求参考</Text>
                            <Paragraph className="schedule-draft-config-help">控制运输需求参考信息是否进入时间线。</Paragraph>
                        </div>
                        <Switch checked={showDemandReferences} onChange={onToggleDemandReferences} />
                    </div>
                ) : null}

                <div className="schedule-draft-config-section-header">
                    <div>
                        <Text strong>参考轨挂载</Text>
                        <Paragraph className="schedule-draft-config-help">挂载参考轨不会写入当前计划航班；移除只会卸载来源。</Paragraph>
                    </div>
                    {onOpenAddReferenceTrack ? (
                        <Button size="small" type="primary" icon={<PlusOutlined />} onClick={onOpenAddReferenceTrack}>
                            挂载参考轨
                        </Button>
                    ) : null}
                </div>

                <div>
                    <Text strong>已挂载参考轨</Text>
                    <Paragraph className="schedule-draft-config-help">
                        第一条参考轨会作为当前编辑轨的主对比基线。你可以调整顺序或移除挂载。
                    </Paragraph>
                    {referenceTrackItems.length ? (
                        <div className="schedule-draft-config-track-list">
                            {referenceTrackItems.map((track, index) => (
                                <div key={track.key} className="schedule-draft-config-track-row is-visible">
                                    <div className="schedule-draft-config-track-main">
                                        <Space wrap size={[6, 6]}>
                                            <Tag color={track.sourceType === "HISTORY" ? "blue" : "purple"}>{track.sourceType}</Tag>
                                            <Tag color="cyan">Mounted</Tag>
                                            {track.isPrimary ? <Tag color="gold">Primary baseline</Tag> : null}
                                            <Tag>{`${track.flightCount || 0} flights`}</Tag>
                                        </Space>
                                        <Text>{track.label}</Text>
                                        <Text type="secondary">{track.description}</Text>
                                    </div>

                                    <Space size={[4, 4]}>
                                        <Button size="small" icon={<ArrowUpOutlined />} onClick={() => onMoveReferenceTrack(track.key, "up")} disabled={index <= 0} />
                                        <Button size="small" icon={<ArrowDownOutlined />} onClick={() => onMoveReferenceTrack(track.key, "down")} disabled={index >= referenceTrackItems.length - 1} />
                                        <Button size="small" danger icon={<DeleteOutlined />} onClick={() => onRemoveReferenceTrack(track.key)}>
                                            移除
                                        </Button>
                                    </Space>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <Empty description="暂无已挂载参考轨" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )}
                </div>

                {tracks.length ? (
                    <div>
                        <Text strong>历史快照快捷挂载</Text>
                        <Paragraph className="schedule-draft-config-help">历史快照可作为只读参考轨挂载，不会修改快照内容。</Paragraph>
                        <Space wrap size={[6, 6]}>
                            {tracks
                                .slice()
                                .sort((left, right) => new Date(right.created_at || 0).getTime() - new Date(left.created_at || 0).getTime())
                                .map((track) => {
                                    const isVisible = visibleReferenceTrackIds.includes(String(track.id));
                                    return (
                                        <Button key={track.id} size="small" type={isVisible ? "default" : "primary"} ghost={!isVisible} onClick={() => onToggleReferenceTrack(track.id)}>
                                            {isVisible ? `移除 ${track.name || "历史快照"}` : `挂载 ${track.name || "历史快照"}`}
                                        </Button>
                                    );
                                })}
                        </Space>
                    </div>
                ) : null}

                {primaryReferenceTrack ? (
                    <div className="schedule-draft-config-primary-note">
                        <Text type="secondary">当前主基线：{primaryReferenceTrack.label}</Text>
                    </div>
                ) : (
                    <Text type="secondary">当前未展开任何参考轨，编辑轨差异高亮将暂停。</Text>
                )}
            </Space>
        </Card>
    );
};

export default ScheduleDraftTrackConfigPanel;
